import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, roles }) {
  const { user, checked } = useAuth();
  if (!checked) {
    return (
      <div className="min-h-screen grid place-items-center bg-stone-50">
        <Loader2 className="w-7 h-7 text-emerald-700 animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
}
